export class GeneralModel {
    id: number;
    code: string;
    name: string;
    createdWhen: any;
    createdBy: any;
    modifiedWhen: any;
    modifiedBy: any;
    concurrencyStamp: string;
    isEnabled = true;
    totalCount = 0;
}
